export default "/fonts/feather.eot?ba142c9a3d0f5747c3470e1126aa9e88";